export const blockIconsSocialPeople = (
	<span className='material-symbols-outlined'>people</span>
);
